import TableConfigV3, {
    ColumnTypes,
} from "../../components/TableV3/TableV3Config";

const DeclarationSummaryConfig: TableConfigV3 = {
    id: "uuid",
    columns: [
        // {
        //     title: "Policy ID",
        //     dataIndex: "policyId",
        //     type: ColumnTypes.Number,
        // },
        {
            title: "Total Goods Value",
            dataIndex: "totalGoodsValue",
            type: ColumnTypes.Money,
            sorter: true,
        },
        {
            title: "Declaration Date",
            dataIndex: "declarationDateStr",
            // type: ColumnTypes.yyyy_mm_dd,
            sorter: true,
        },
        {
            title: "No of declarations",
            dataIndex: "totalCount",
            type: ColumnTypes.Number,
            sorter: true,
        }
    ],
};

export default DeclarationSummaryConfig;
